module.exports = __webpack_public_path__ + "static/mob-ppl-61f6d5d469d0f68a2711fd86ccc88c3c.svg";